import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import { setGuardian } from "../../Redux/Slices/studentAdmission.slice";
import { GuardianInfo } from "../Guardian/GuardianInfo";
import { Guardian } from "../../Models/guardian.models";

const StudentAdmissionFormStepFour = () => {
  const dispatch = useDispatch();
  const { guardianInfo } = useSelector((state: RootState) => ({
    guardianInfo: state.studentAdmission.guardianInfo,
  }));

  const addGuardian = (updatedGuardianInfo: Guardian[]) => {
    dispatch(setGuardian(updatedGuardianInfo));
  };

  const removeGuardian = (updatedGuardianInfo: Guardian[]) => {
    dispatch(setGuardian(updatedGuardianInfo));
  };

  return (
    <div className="flex flex-row gap-x-10 px-2">
      <div className="flex-1">
        <>
          <GuardianInfo
            guardians={guardianInfo}
            onAddGuardian={(updatedGuardianInfo: Guardian[]) =>
              addGuardian(updatedGuardianInfo)
            }
            onRemoveGuardian={removeGuardian}
            onGuardianInfoChange={(updatedGuardianInfo) => {
              dispatch(setGuardian(updatedGuardianInfo));
            }}
            totalGuardian={guardianInfo.length}
          />
        </>
      </div>
    </div>
  );
};

export default StudentAdmissionFormStepFour;
